import clsx from 'clsx';
import React from 'react';
import Button from '../core/Button';
import styles from './StepForm.module.scss';

interface Props {
  actions?: 'saveAndExit';
  nextBtnLabel?: string;
  hideBackBtn?: boolean;
  showPublishBtn?: boolean;
  disabled?: boolean;
  className?: string;
  onBackClick?: () => void;
  onNextClick?: () => void;
  onPublishClick?: () => void;
  onSaveAndExitClick?: () => void;
}

export default function StepFormSubStepButtons(props: Props) {
  return (
    <div className={clsx(styles.stepFormSubStepButtons, props.className)}>
      {props.actions === 'saveAndExit' ? (
        <>
          {props.showPublishBtn ? (
            <Button
              disabled={props.disabled}
              label="Publicar"
              onClick={props.onPublishClick}
            />
          ) : null}
          <Button
            disabled={props.disabled}
            label="Guardar y salir"
            onClick={props.onSaveAndExitClick}
          />
        </>
      ) : (
        <>
          {Boolean(props.hideBackBtn) ? null : (
            <Button
              disabled={props.disabled}
              variant="outlined"
              onClick={props.onBackClick}
              label="Atrás"
            />
          )}
          <Button
            disabled={props.disabled}
            type="submit"
            onClick={props.onNextClick}
            label={props.nextBtnLabel ?? 'Siguiente'}
          />
        </>
      )}
    </div>
  );
}
